import { useMemo } from 'react';
import PublicDataTable from '../PublicDataTable';
import ContactCell from '../ContactCell';
import StatusBadge from '../ProfessionalStatusBadge';
import { PillTabs } from '../Directory';
import { ANIMAL_HEALTH_CATEGORIES } from '../../data/animalHealthData';

const CATEGORY_TABS = ANIMAL_HEALTH_CATEGORIES.map(({ key, label }) => ({ key, label }));

/**
 * Animal Health Facilities tab.
 *   Table view — Figma 497:47867 (and the laboratories / surveillance /
 *     pharmacies siblings): sub-tab pills, then a table whose Action column
 *     ("View") calls `onView` — the page then shows FacilityMapView.
 *
 * Props
 *   rows             records of the active sub-tab, already filtered by state/type
 *   searchQuery      live search text from the page header
 *   activeCategory   active sub-tab key (lifted to the page)
 *   onCategoryChange fn
 *   onView           fn(row) — "View" clicked
 */
export default function AnimalHealthFacilities({ rows, searchQuery, activeCategory, onCategoryChange, onView }) {
  const columns = useMemo(() => [
    { key: 'name',           title: 'Name' },
    { key: 'contactPhone',   title: 'Contact', divider: true, render: (v) => <ContactCell number={v} /> },
    { key: 'practice',       title: 'Practice / Facility' },
    { key: 'category',       title: 'Professional Category' },
    { key: 'specialisation', title: 'Specialisation' },
    { key: 'services',       title: 'Services Provided' },
    { key: 'licence',        title: 'Licence / Registration No' },
    { key: 'status',         title: 'Professional Status', render: (v) => <StatusBadge status={v || '—'} /> },
    {
      key: '__action',
      title: 'Action',
      render: (_, row) => (
        <button
          type="button"
          onClick={() => onView(row)}
          className="text-[11px] font-medium text-[#28ba12] underline underline-offset-2 hover:no-underline"
        >
          View
        </button>
      ),
    },
  ], [onView]);

  return (
    <div>
      <PillTabs tabs={CATEGORY_TABS} active={activeCategory} onChange={onCategoryChange} />
      <div className="mt-4">
        <PublicDataTable key={activeCategory} columns={columns} data={rows} searchQuery={searchQuery} pageSize={10} />
      </div>
    </div>
  );
}
